
  var style = require("icon-maker-loader/.tmp/6d5d789f-feed-453f-bcf8-e3f6c88b6f96/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-find"];
  } else {
    module.exports = "icon-maker icon-maker-find";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/find.svg
// module id = 540
// module chunks = 5